export enum ConsentsEnum {
  ACCEPTMARKETINGAUTOMATEDCONTACT = 'ACCEPTMARKETINGAUTOMATEDCONTACT',
  ACCEPTMARKETINGCONTACT = 'ACCEPTMARKETINGCONTACT',
  BIKCHECKACCEPTED = 'BIKCHECKACCEPTED',
  CrifAddressDataSharingConsent = 'CrifAddressDataSharingConsent',
  CrifDataDownloadConsent = 'CrifDataDownloadConsent',
  CrifDataSharingConsent = 'CrifDataSharingConsent',
  DPDLOWERTHANTHRESHOLD = 'DPDLOWERTHANTHRESHOLD',
  ECONOMICBUREAUSACCEPTED = 'ECONOMICBUREAUSACCEPTED',
  ERIFCHECKACCEPTED = 'ERIFCHECKACCEPTED',
  Group0 = 'Group_0',
  Group1 = 'Group_1',
  Group2 = 'Group_2',
  HiProFirstGroup = 'first_group_terms_agreed',
  HiProSecondGroup = 'second_group_terms_agree',
  HiProThirdGroup = 'third_group_terms_agreed',
  MarketingConsentInfo = 'Zaznacz tę zgodę i nie przegap nowych promocji dla klientów Mubi!',
  OurGoal = 'Naszym celem jest, aby polscy kierowcy mogli łatwo i wygodnie wyszukiwać najlepsze ubezpieczenia OC i AC.',
  OurGoalTravel = 'Naszym celem jest, aby podróżujący mogli łatwo i wygodnie znaleźć najlepsze ubezpieczenie turystyczne.',
  PleaseAcceptOurPolitic = 'Abyśmy mogli porównać ceny ofert również dla Ciebie, prosimy o zaakceptowanie naszej ',
  PleaseAcceptOurPoliticTravel = 'Abyśmy mogli porównać oferty również dla Ciebie, prosimy o zaakceptowanie naszej ',
  TravelDetailsInformation = 'Powyżej przedstawiono skrót najważniejszych informacji o\xa0zakresie ubezpieczenia.\nSzczegółowe warunki, w\xa0tym wyłączenia odpowiedzialności, znajdziesz w\xa0OWU.',
  WONGATERMSAGREED = 'WONGATERMSAGREED',
}
